
import crud from "./_crud";

const actions = crud('state', 'el estado', 'los estados');

export default actions